import React from "react";
import { connect } from "react-redux";
import { Layout } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import Logo from "./Logo";
import NavProfile from "./NavProfile";
import NavRoleSelector from "./NavRoleSelector";
import {
  toggleCollapsedNav,
  onMobileNavToggle,
} from "../../redux/actions/Theme";
import {
  NAV_TYPE_TOP,
  SIDE_NAV_COLLAPSED_WIDTH,
  SIDE_NAV_WIDTH,
} from "../../constants/ThemeConstant";
import utils from "../../utils";
import { useLocation } from "react-router-dom";
import navigationConfig from "../../configs/NavigationConfig";
import IntlMessage from "../util-components/IntlMessage";
import NavTeamSelector from "./NavTeamSelector";

const { Header } = Layout;

export const HeaderNavMinimal = (props) => {
  const {
    navCollapsed,
    mobileNav,
    navType,
    headerNavColor,
    pageHeaderOverride,
    toggleCollapsedNav,
    onMobileNavToggle,
    isMobile,
    currentTheme,
  } = props;

  const isNavTop = navType === NAV_TYPE_TOP;
  const navMode = headerNavColor
    ? utils.getColorContrast(headerNavColor)
    : utils.getColorContrast(currentTheme === "dark" ? "#00000" : "#ffffff");

  const getNavWidth = () => {
    if (isNavTop || isMobile) return "0px";
    return navCollapsed ? `${SIDE_NAV_COLLAPSED_WIDTH}px` : `${SIDE_NAV_WIDTH}px`;
  };

  const onToggle = () => {
    if (!isMobile) {
      toggleCollapsedNav(!navCollapsed);
    } else {
      onMobileNavToggle(!mobileNav);
    }
  };

  const location = useLocation();
  const currentRouteInfo = utils.getRouteInfo(
    navigationConfig,
    location.pathname
  );

  return (
    <Header
      className={`app-header ${navMode}`}
      style={{ backgroundColor: headerNavColor, zIndex: "999" }}
    >
      <div className={`app-header-wrapper ${isNavTop ? "layout-top-nav" : ""}`}>
        <Logo logoType={navMode} />
        <div className="nav" style={{ width: `calc(100% - ${getNavWidth()})` }}>
          {/* Flexible regions: left/right take equal share so the title stays centered,
              while the left region can grow to fit the (long) team-selector label.
              Previously the left was pinned to 33%, so expanding the sidebar shrank it
              and clipped the team detail out of the header. */}
          <div className="nav-left" style={{ flex: "1 1 0", minWidth: 0, overflow: "hidden" }}>
            <ul className="ant-menu ant-menu-root ant-menu-horizontal">
              {isNavTop && !isMobile ? null : (
                <li
                  className="ant-menu-item ant-menu-item-only-child"
                  onClick={onToggle}
                >
                  {navCollapsed || isMobile ? (
                    <MenuUnfoldOutlined className="nav-icon" />
                  ) : (
                    <MenuFoldOutlined className="nav-icon" />
                  )}
                </li>
              )}
              <NavTeamSelector />
            </ul>
          </div>
          <div style={{ flex: "0 0 auto", padding: "0 1rem" }} className="text-white text-center">
            {currentRouteInfo?.key !== "user-management" && (
              <span style={{ fontSize: "20px", fontWeight: "semi-bold" }}>
                {pageHeaderOverride ? (
                  <IntlMessage id={pageHeaderOverride} />
                ) : currentRouteInfo?.title ? (
                  <IntlMessage id={currentRouteInfo.title} />
                ) : null}
              </span>
            )}
          </div>
          <div
            className="nav-right d-flex align-items-center"
            style={{ flex: "1 1 0", minWidth: 0, marginLeft: 0, justifyContent: "flex-end" }}
          >
            <NavRoleSelector />
            <NavProfile />
          </div>
        </div>
      </div>
    </Header>
  );
};

const mapStateToProps = ({ theme }) => {
  const {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
    pageHeaderOverride,
  } = theme;
  return { navCollapsed, navType, headerNavColor, mobileNav, currentTheme, pageHeaderOverride };
};

export default connect(mapStateToProps, {
  toggleCollapsedNav,
  onMobileNavToggle,
})(HeaderNavMinimal);

